import { ActionType } from "../constants/map";
import { mapApi } from "../../api/map/map";


export const getMapAction = resort_id => async dispatch => {
  try {
    dispatch({type: ActionType.GET_MAP_START })
    const res = await mapApi(resort_id)
    dispatch({ type: ActionType.GET_MAP_SUCCESS,payload: res.data})
    const resort = res.data.resort[0]
    dispatch(setCardDetailsAction({country: resort.region.parent_region.name, region: resort.region.name, resort: resort.name }))
  } catch (error) {
    dispatch({type: ActionType.GET_MAP_ERROR,payload: error.response });
  }
}

export const erasePastMapHandler = () => dispatch => {
  return dispatch({
    type: ActionType.DELETE_MAP
  });
};

export const setColorAction = color => dispatch => {
  return dispatch({
    type: ActionType.SET_COLOR,
    payload: color
  });
};

export const setCardDetailsAction = (value) => dispatch => {
  return dispatch({
    type: ActionType.SET_DETAILS,
    payload: value,
  });
};
